<template>
  <app-bar>
    <div class="w-100">
      <div class="d-flex flex-row">
        <!-- Company Name and Logo -->
        <div
          class="scss-click-effect w-65 my-auto scss-title d-flex justify-content-start"
          @click="goToAbout"
        >
          <smart-image
            :imageURL="init.companyImage"
            class="style-company-image"
          />

          <span class="my-auto ms-2 text-truncate">{{ init.companyName }}</span>
        </div>
        <!-- Select Branch Button -->
        <div
          class="d-flex flex-row align-items-center w-35 scss-click-effect justify-content-end"
          @click="goToSelectBranch"
        >
          <i class="material-icons style-icon-size my-auto">store</i>
          <div
            class="ms-1 text-start style-branch-name"
            :style="{ 'font-size': branchNameFontSize }"
          >
            {{ selectedBranch.name }}
          </div>
          <i class="bi bi-three-dots-vertical" style="padding-left:1rem"></i>
        </div>
      </div>
    </div>
  </app-bar>
</template>

<script>
import { mapGetters } from "vuex";
import SmartImage from "../../../components/SmartImage.vue";
import AppBar from "@/components/AppBar.vue";

export default {
  name: "BranchInformation",
  components: { SmartImage, AppBar },
  methods: {
    goToAbout() {
      this.$router.push("/about");
    },
    goToSelectBranch() {
      this.$router.push("/branch");
    },
  },
  computed: {
    branchNameFontSize() {
      const firstWordOfBranchName =
        this.selectedBranch && Object.keys(this.selectedBranch).length !== 0
          ? this.selectedBranch.name.split(" ")[0]
          : "";

      return firstWordOfBranchName.length > 8
        ? `${12 - (firstWordOfBranchName.length - 8) / 2}px`
        : "12px";
    },
    ...mapGetters(["init", "selectedBranch"]),
  },
};
</script>

<style lang="scss" scoped>
.style-company-image {
  max-width: 65px;
  height: 30px;
  object-fit: contain;
}
i {
  font-size: 20px;
}
.style-icon-size {
  font-size: 25px;
}

.style-branch-name {
  max-height: 50px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  display: -webkit-box;
  line-height: 1.2;
}
</style>
